<template>
  <div>
    <div v-if="!isMobileDevice()" class="title">
      <div>
        <img v-if="method === '支付宝'" src="~@/assets/svg/ali_app.svg" alt="">
        <img v-if="method === '微信'" src="~@/assets/svg/wx_app.svg" alt="">
      </div>
      <p style="font-size:18px;margin-left: 12px;">{{ method }}扫码支付</p>
    </div>
    <div v-if="!isMobileDevice()" class="order-info">
      <p style="font-size:36px;">￥{{amount}}</p>
      <vueQr :text="payUrl" :size="270"/>
      <!--    <p v-if="!isMobileDevice()" class="pay-info-link" @click="copyToClipboard">{{copyText}}</p>-->
      <p style="font-size:18px;">订单号：{{orderNo}}</p>
      <div style="display: flex;align-items: center;justify-content: center;">
        <img src="~@/assets/svg/qr_cashier.svg" alt="">
        <p style="font-size:18px;margin-left: 12px;">扫描二维码完成支付</p>
      </div>
    </div>
    <div v-if="isMobileDevice()" style="display: flex;align-items: center;justify-content: center;">
      <img src="~@/assets/images/loading.gif" alt="">
      <p style="font-size:18px;margin-left: 12px;">正在跳转...</p>
    </div>
  </div>
</template>

<script>
import {redirectCashier,getOrderInfo} from '@/api/api'
import vueQr from 'vue-qr'
import Clipboard from 'clipboard';

export default {
  name: "Redirect",
  components: {vueQr},
  data() {
    return {
      orderNo: '',
      payUrl: '',
      copyText: '',
      amount:'0.00',
      method: '手机'
    }
  },
  mounted() {
    this.pay();
  },
  methods: {
    isMobileDevice: function() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    pay: function () {
      const {method, token} = this.$router.history.current.params;

      if (method === 'wxpay') {
        this.method = '微信';
      } else if (method === 'alipay') {
        this.method = '支付宝';
      } else if (method === 'up') {
        this.method = '云闪付';
      }

      if (token) {
        getOrderInfo(token).then(info => {
          redirectCashier(token).then(res => {
            this.orderNo = res.payOrderId;
            if (this.isMobileDevice()) {
              window.location.href = res.payInfo;
            } else {
              this.amount = info.amount / 100;
              this.copyText = res.payInfo;
              this.payUrl = res.payInfo;
            }
          });
        })
      }
    },
    copyToClipboard() {
      const clipboard = new Clipboard('p', {
        text: () => this.copyText
      });

      clipboard.on('success', () => clipboard.destroy());

      clipboard.on('error', () => clipboard.destroy());
    }
  }
}
</script>

<style scoped>

.title{
  text-align: center;
  border-bottom: 1px solid #ddd;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
}

.order-info{
  width: 510px;
  margin: 18px auto 0 auto;
  text-align: center;
  border: 1px solid #e5e5e5;
  background-color: white;
}

.pay-info-link {
  font-size: .09rem;
  cursor: pointer;
  background-color: lightgrey;
  padding: 5px;
  margin: 0 30%;
  word-break: break-all;
}
</style>